import React from 'react';
import { motion } from 'framer-motion';
import { FolderOpen, Target, Tag } from 'lucide-react';
import { noteColors } from './constants';

export const NoteCard = ({ note, onClick }) => {
  const colorStyle = noteColors[note.color] || noteColors.yellow;
  const isTask = note.is_task;
  const isProject = note.is_project;

  return (
    <motion.div
      layout
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.8 }}
      whileHover={{ scale: 1.02, rotate: Math.random() * 2 - 1 }}
      onClick={() => !isTask && !isProject && onClick?.(note)}
      className={`
        relative p-3 rounded-lg cursor-pointer
        ${colorStyle.bg} ${colorStyle.border} border
        shadow-md hover:shadow-lg transition-shadow
        min-w-[120px] max-w-[180px]
      `}
      style={{
        transform: `rotate(${(note.position || 0) % 5 - 2}deg)`
      }}
      data-testid={`note-card-${note.id}`}
    >
      {/* Pin decoration */}
      <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-4 h-4 rounded-full bg-red-500 shadow-md border-2 border-red-600" />
      
      {/* Category badge */}
      {note.category && (
        <div className="flex items-center gap-1 mb-2">
          <Tag className="h-3 w-3 text-slate-500" />
          <span className="text-xs font-medium text-slate-500 uppercase truncate">
            {note.category}
          </span>
        </div>
      )}
      
      {/* Image thumbnail */}
      {note.image && (
        <div className="mb-2 rounded overflow-hidden">
          <img 
            src={note.image} 
            alt="" 
            className="w-full h-16 object-cover"
          />
        </div>
      )}
      
      {/* Content */}
      <p className={`text-sm text-slate-800 break-words ${isTask && note.completed ? 'line-through opacity-60' : ''}`}>
        {note.content}
      </p>
      
      {/* Project/Task indicator */}
      {(isProject || isTask) && (
        <div className="flex items-center gap-1 mt-2 text-xs text-slate-500">
          {isProject ? <FolderOpen className="h-3 w-3" /> : <Target className="h-3 w-3" />}
          <span className="truncate">{note.project_name}</span>
        </div>
      )}
    </motion.div>
  );
};

export default NoteCard;
